import $ from 'jquery';
import 'slick-carousel';

export default function initLoginSlider() {
  $(() => {
    const $loginSlider = $('.c-login-slider');

    if ($loginSlider.length) {
      $loginSlider.slick({
        autoplay: true,
        autoplaySpeed: 6000,
        speed: 1000,
        arrows: false,
        dots: false,
        fade: true,
        infinite: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        draggable: false,
        swipe: false,
        touchMove: false
      });
    }
  });
}
